import './ec-progress.less';

let ecProgress = ({echarts, dom, tip, value, tipNoValue, bg}) => {
    echarts.dispose(dom);
    dom.classList.add('ec-progress-wrap');
    let myChart = echarts.init(dom);
    let barWidth = 8;

    // 瞧我变量名起得好垃圾
    if (tipNoValue) {
        if (value < 90) {
            value = value * 0.8;
        } else if (value >= 90) {
            let d = value - 90;
            value = 80 + d * 2;
        }
    }


    let option = {
        tooltip: {
            // trigger: 'axis',
            show: true,
            formatter: tipNoValue ? "{b}" : "{b} <br> {c}%"
        },
        grid: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        },
        xAxis: [{
            axisTick: {
                show: false,
            },
            axisLine: {
                show: false,
            },
            axisLabel: {
                show: false
            },
            splitLine: {
                show: false,
            }
        }],
        yAxis: [{
            type: 'category',
            data: [tip],

            axisTick: {
                show: false,
            },
            axisLine: {
                show: false,
            },
            axisLabel: {
                show: false,
                textStyle: {color: '#fff'}
            }

        }],
        series: [
            {
                type: 'bar',
                name: 'bg',
                barWidth: barWidth,
                silent: true,
                itemStyle: {
                    normal: {
                        color: 'rgba(93,115,176,0.15)',
                        // barBorderRadius: [barWidth/2],
                    }
                },
                barGap: '-100%',
                barCategoryGap: '50%',
                data: [100]
            },
            {
                type: 'bar',
                name: 'cover',
                barWidth: barWidth,
                label: {
                    normal: {
                        show: false,
                        position: 'top',
                        formatter: '{c}%',
                    }
                },
                data: [{
                    value: value || 1,
                    itemStyle: {
                        normal: {
                            // barBorderRadius: [barWidth / 2],
                            color: {
                                type: 'bar',
                                colorStops: [{
                                    offset: 0,
                                    color: bg[0] || '#E559B6' // 0% 处的颜色
                                }, {
                                    offset: 1,
                                    color: bg[1] || '#FFEA96' // 100% 处的颜色
                                }],
                                globalCoord: false, // 缺省为 false
                            }
                        }
                    }
                }]
            }
        ]
    };

    myChart.setOption(option, true);
};

export default ecProgress;
